<template>
  <div class="my-3">
    <label>Start With</label>
    <div class="border">
      <div class="row p-3">
        <div class="col-sm-12 col-md-3 col-lg-3">
          <router-link
            :to="{
              name: 'AdminPointPrograms',
            }"
            >Programs & Contests</router-link
          >
        </div>
        <div class="col-sm-12 col-md-3 col-lg-3">
          <router-link
            :to="{
              name: 'AdminPointProgramsEditClients',
            }"
            >Locations or companies</router-link
          >
        </div>
        <div class="col-sm-12 col-md-3 col-lg-3">
          <router-link
            :to="{
              name: 'AdminPointProgramsNewProgramContest',
            }"
            >New Program/Contest</router-link
          >
        </div>
        <div class="col-sm-12 col-md-3 col-lg-3">
          <router-link
            :to="{
              name: 'AdminAddPoints',
            }"
            >Add Points</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PointProgramsStartWith",

  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
</style>
